import { css } from '@emotion/css';
import { Row, Col, Skeleton, Space } from 'antd';
import { MCard, MTypography } from 'src/lib';
import { AlignItems, ColorConstant, Display, FlexDirection, ScreenBreakpoint, Spacing } from 'src/styles';

import { PortofolioSummaryInfo } from './accountSummary.model';
import SummaryChart from './SummaryChart';
import SummaryInfo from './SummaryInfo';

export const titleRowStyle = css`
  ${Spacing.mt32}
  ${Spacing.mb12}
`;

export const spaceStyle = css`
  ${AlignItems.center}

  .ant-space-item:last-child {
    width: inherit;
  }

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Display.flex}
    ${FlexDirection.column}

    .ant-space-item:first-child {
      ${Spacing.mAuto};
    }
  }
`;

export const cardStyle = css`
  ${Spacing.p24}
  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    .ant-card-body {
      ${Spacing.px4};
    }
  }
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: auto;
    ${Spacing.mx16};
  }
`;

interface AccountSummaryProps {
  title: string;
  isLoading: boolean;
  accountValue: number;
  portofolio: PortofolioSummaryInfo;
  infoTitle: string;
  onRefresh: () => void;
}

export const AccountSummary = ({
  title,
  isLoading,
  accountValue,
  portofolio,
  infoTitle,
  onRefresh,
}: AccountSummaryProps) => {
  return (
    <Skeleton loading={isLoading}>
      <Row className={titleRowStyle}>
        <MTypography variant='h4' weight='semibold' color={ColorConstant.BRAND6}>
          {title}
        </MTypography>
      </Row>
      <Row justify='center'>
        <Col span={24}>
          <MCard className={cardStyle}>
            <Row>
              <Col span={24}>
                <Space align='start' size={16} className={spaceStyle}>
                  <SummaryChart accountValue={accountValue} portofolio={portofolio} />
                  <SummaryInfo infoTitle={infoTitle} portofolio={portofolio} onRefresh={onRefresh} />
                </Space>
              </Col>
            </Row>
          </MCard>
        </Col>
      </Row>
    </Skeleton>
  );
};
